import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { materialGoodsIssueBusiness } from "api/bussiness/material/material-goods-issue";
import { MaterialInventoriesPermission } from "commons/enum/permission";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IMaterialGoodsIssueProperties } from "mobx-stores/_models/material-inventory/material-goods-issue/material-goods-issue";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { NumberText } from "share-components/atomics/number-text";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const MaterialGoodsIssueTable = observer(() => {
  const {
    deleteConfirmationStore,
    materialInventoryManagement: {
      materialGoodsIssueStore: {
        materialGoodsIssues,
        getMaterialGoodsIssue,
        pagination,
        setProp,
      },
    },
  } = useStores();

  useEffect(() => {
    getMaterialGoodsIssue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getMaterialGoodsIssue();
    },
    [getMaterialGoodsIssue, pagination],
  );

  const onEditBtnClickHandler = useCallback(
    (item: IMaterialGoodsIssueProperties) => {
      setProp("openEdit", true);
      setProp("materialGoodsIssueDetail", cloneDeep(item));
    },
    [setProp],
  );

  const onDelete = useCallback(
    async (item: IMaterialGoodsIssueProperties) => {
      if (item && item.id) {
        await materialGoodsIssueBusiness.delete(item?.id);
        getMaterialGoodsIssue();
      }
    },
    [getMaterialGoodsIssue],
  );

  const onDeleteBtnClickHandler = useCallback(
    (item: IMaterialGoodsIssueProperties) => {
      setProp("materialGoodsIssueDetail", cloneDeep(item));
      deleteConfirmationStore.setProp("open", true);
      deleteConfirmationStore.setDeletionCallback(() => {
        onDelete(item);
      });
    },
    [deleteConfirmationStore, onDelete, setProp],
  );
  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell style={{ textWrap: 'nowrap' }}>Bộ phận/Khâu SX</TableCell>
          <TableCell>Loại Hàng</TableCell>
          <TableCell>Hiệu</TableCell>
          <TableCell>Tên Hàng (Mã Hàng)</TableCell>
          <TableCell>Mã barcode</TableCell>
          <TableCell>Dài (Ngang)</TableCell>
          <TableCell>Rộng (Dọc)</TableCell>
          <TableCell>Cao (Dày)</TableCell>
          <TableCell>Ngày xuất</TableCell>
          <TableCell>Số LSX</TableCell>
          <TableCell>Bộ phận</TableCell>
          <TableCell>Số lượng</TableCell>
          <TableCell>Ghi chú</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {materialGoodsIssues.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.items[0]?.material?.code || ""}</TableCell>
            <TableCell>{x.items[0]?.material?.type || ""}</TableCell>
            <TableCell>{x.items[0]?.brand || ""}</TableCell>
            <TableCell>{x.items[0]?.material?.name || ""}</TableCell>
            <TableCell>{x.items[0]?.material?.barcode || ""}</TableCell>
            <TableCell>
              {x.items[0]?.material?.specificationSize || ""}
            </TableCell>
            <TableCell>
              {x.items[0]?.material?.specificationLength || ""}
            </TableCell>
            <TableCell>
              {x.items[0]?.material?.specificationThick || ""}
            </TableCell>
            <TableCell>{dateTimeDisplay(x.issueDate) || ""}</TableCell>
            <TableCell>
              {x.items[0]?.workOrderPO?.woNumber ||
                x.items[0]?.workOrder?.woNumber ||
                ""}
            </TableCell>
            <TableCell>{x.items[0]?.department || ""}</TableCell>
            <TableCell>
              <NumberText value={x.items[0]?.amount}></NumberText>
            </TableCell>
            <TableCell>{x.items[0]?.note || ""}</TableCell>
            <TableCell width={"20px"}>
              <Stack direction={"row"} spacing={0.5}>
                <EditIconButton
                  accessPermission={[MaterialInventoriesPermission.IssueUpdate]}
                  onClick={() => onEditBtnClickHandler(x)}
                ></EditIconButton>

                <RemoveIconButton
                  accessPermission={[MaterialInventoriesPermission.IssueDelete]}
                  onClick={() => onDeleteBtnClickHandler(x)}
                ></RemoveIconButton>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
